<template>
  <div>    
    <div class="row">
      <div class="col">       

        <iframe :src="telescopeUrl" width="100%"  frameborder="0" height="600"></iframe>

      </div>
    </div>
  </div>
</template>

<script>



export default {
  mounted() {
  
  },

  methods: {
   
  },

  data() {
    return {
     telescopeUrl:process.env.VUE_APP_API_PATH+"/telescope",
    };
  }
};
</script>

<style>
</style>